import {
  Alert,
  Box,
  Button,
  Divider,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { PRO_TERMS_AND_CONDITIONS_LINK } from "constants/influencer";
import { trackEvent } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import PlansPrice from "../SharedComponents/Price";
import { PlanAction, getCurrentPlanButton } from "../helpers";

const MobilePlanCardPro = () => {
  const { onPlanButtonClick } = useSubscription();
  const { currentOrg, organizationProProfile } = useContext(
    OrganizationUserContext,
  );
  const { plans, subscription } = useContext(SubscriptionContext);
  const totalEmails = plans?.[Plans.PRO]?.monthly_limit || 0;
  const action = getCurrentPlanButton(
    Plans.PRO,
    subscription?.subscription?.planName || Plans.FREE,
    subscription,
  );

  const trackTermsAndCondition = () => {
    trackEvent("Terms and Conditions for Pro Plan Clicked", {
      source: "Onboarding Paywall",
    });
  };

  return (
    <Box sx={{ backgroundColor: "white", borderRadius: 3, mt: 1 }}>
      <Grid container justifyContent={"flex-end"} sx={{ pr: 1.5, pt: 1.5 }}>
        <Box
          sx={{
            backgroundColor: "yellow.main",
            borderRadius: 6,
            px: 2,
            py: 0.5,
            fontSize: 11,
            mb: 2,
            fontWeight: 600,
          }}
        >
          11x more likely to land a deal
        </Box>
      </Grid>

      <Box sx={{ px: 2, pb: 3 }}>
        <Grid container justifyContent="space-between" alignItems="flex-end">
          <Typography variant="h4" sx={{ fontSize: 26 }}>
            Pro Plan
          </Typography>
          <PlansPrice plan={Plans.PRO} />
        </Grid>

        <Divider sx={{ my: 1, backgroundColor: "black" }} />

        <Typography sx={{ fontSize: 14, lineHeight: 2 }}>
          🚀 Send {totalEmails} Emails per month
          <br />
          🧠 Advanced brand filters <br />
          📈 Reply likelihood for each contact <br />
          🔑 Get access to 600k contacts <br />
          💰 Monthly reminders to close deal
        </Typography>

        {organizationProProfile?.planConfig?.monthlyLimit &&
          organizationProProfile.planConfig.monthlyLimit !== totalEmails && (
            <Alert severity="info">
              <Typography
                sx={{
                  fontSize: 12,
                  color: "black",

                  fontWeight: 500,
                }}
              >
                As an existing subscriber, your Pro plan includes{" "}
                <strong>
                  {organizationProProfile.planConfig.monthlyLimit} emails/month
                </strong>{" "}
              </Typography>
            </Alert>
          )}

        {!currentOrg?.overridePlanName && (
          <Button
            disableElevation
            fullWidth
            variant={action === PlanAction.upgrade ? "contained" : "text"}
            sx={{
              fontSize: 16,
              mt: 2,
              py: 1,
              borderRadius: 2,
              backgroundColor:
                action === PlanAction.upgrade ? "primary.main" : "#f4f8f6",
            }}
            onClick={() => onPlanButtonClick(Plans.PRO, action)}
          >
            Upgrade to Pro
          </Button>
        )}
        <Typography textAlign={"center"} sx={{ mt: 2 }}>
          <Link
            href={PRO_TERMS_AND_CONDITIONS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackTermsAndCondition}
            sx={{
              color: "secondary.dark",
              fontSize: 14,
              textDecoration: "none",
            }}
          >
            Terms & Conditions
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default MobilePlanCardPro;
